window.addEventListener('DOMContentLoaded', function() {
    var searchInput = document.getElementById('search-input');
    var searchButton = document.getElementById('search-button');

    // Optional: Add event listener for 'Enter' key in search input
    searchInput.addEventListener('keypress', function(event) {
        if (event.key === 'Enter') {
            event.preventDefault();
            searchButton.click();
        }
    });
});